import { defineMessages } from 'react-intl';

export const messages: {
	buildAppButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reviewSpecsButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	buildAppButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.build-app-button-label',
		defaultMessage: 'Build app',
		description: 'Build app button label (displayed at the footer of the card)',
	},
	reviewSpecsButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.review-specs-button-label',
		defaultMessage: 'Review app specs',
		description: 'Review app specs button label (displayed at the footer of the card)',
	},
});
